import { ParticipantDTO } from "./participant-dto";

export class Participant {

    public ID: string;
    public name: string;
    public targetURL: string;
    public supportedProtocols: string[];

    constructor(
        ID: string,
        name: string,
        targetURL: string,
        supportedProtocols: string[]
    ) {
        this.ID = ID;
        this.name = name;
        this.targetURL = targetURL;
        this.supportedProtocols = supportedProtocols;
    }

    public static createFromDTO(dto: ParticipantDTO): Participant {
        return new Participant(
            dto.id,
            dto.name,
            dto.targetUrl,
            dto.supportedProtocols
        );
    }

}